const boost = {
  // Page titles
  boostTitle: 'ترقية الإعلان',
  boostSubtitle: 'اجعل إعلانك يظهر لعدد أكبر من العملاء المهتمين',

  // Property reference
  boostingProperty: 'ترقية الإعلان:',

  // Boost types
  featured: 'إعلان مميز',
  featuredPlus: 'إعلان مميز بلس',

  // Labels
  recommended: 'موصى به',
  popular: 'الأكثر شيوعاً',
  days: 'يوم',
  month: 'شهر',

  // Features
  features: {
    higherRanking: 'ظهور أعلى في نتائج البحث',
    featuredBadge: 'شارة "مميز" على الإعلان',
    highlighted: 'تمييز بلون خاص',
    morePhotos: 'صور وفيديو أكثر',
    analytics: 'إحصائيات مفصلة',
    homepage: 'ظهور في الصفحة الرئيسية',
    aiOptimization: 'تحسين المحتوى بالذكاء الاصطناعي',
    prioritySupport: 'دعم فني أولوية',
  },

  // Actions
  cancel: 'إلغاء',
  continueToPayment: 'متابعة للدفع',
  confirmBoost: 'تأكيد الترقية',
  boostNow: 'ترقية الآن',
  viewActiveBoosts: 'عرض الترقيات النشطة',

  // Status
  active: 'نشط',
  expired: 'منتهي',
  pending: 'قيد الانتظار',
  daysRemaining: 'أيام متبقية',

  // Dashboard
  activeBoosts: 'الترقيات النشطة',
  noActiveBoosts: 'لا توجد ترقيات نشطة',
  boostHistory: 'سجل الترقيات',

  // Messages
  boostSuccess: 'تم ترقية الإعلان بنجاح',
  boostError: 'حدث خطأ أثناء ترقية الإعلان',

  // Payment
  paymentPending: 'قيد الدفع',
  paymentComingSoon: 'خدمة الدفع قريباً',
  paymentApiPending: 'سيتم تفعيل خدمة الدفع قريباً. نعمل على ربط بوابة الدفع.',
};

export default boost;
